export const previsualizacionRoutesMap = {
  previsualizacion: {
    path: '/empresa/previsualizacion',
    name: 'Previsualización Factura',
  },
}
